let urlConfig = {};

const prodUrl = {
  "/v_adv_gif": "https://ad.yicai.com",
  "/v_address": "https://whois.pconline.com.cn",
  "/v_adv": "https://amsapi.yicai.com",
  // "/v4": "https://api2021.cbnweek.com/v4",
  // "/v4": "http://121.89.195.28:8082/v5",
  // "/v4": "http://test.shuzi110.com:8081/v5",
  "/v5": "https://api2023.cbnweek.com/v5",
  "/v4": "https://api2023.cbnweek.com/v5",
  "/vtest": "https://test.shuzi110.com/v5",
  "/v3": "https://oa-mssp.data.aliyun.com",
  "/v1": "https://upload.qiniu.com"
};

const testUrl = {
  "/v_adv_gif": "https://ad.yicai.com",
  "/v_address": "https://whois.pconline.com.cn",
  "/v_adv": "https://amsapi.yicai.com",
  // "/v4": "//api2021.cbnweek.com/v4",
  // "/v4": "http://121.89.195.28:8082/v5",
  // "/v4": "http://test.shuzi110.com:8081/v5",
  // "/v4": "https://api2023.cbnweek.com/v5",  //kang edit
  "/v5": "http://121.89.195.28:8082/v5",//kang edit
  "/v4": "http://121.89.195.28:8082/v5",//kang edit
  "/vtest": "https://test.shuzi110.com/v5",
  "/v3": "https://oa-mssp.data.aliyun.com",
  "/v1": "https://upload.qiniu.com"
};

if (process.env.NODE_ENV === "production") {
  urlConfig = prodUrl;
} else {
  urlConfig = testUrl;
}


export default function (config) {
  const { url } = config;
  let connectURL = url;
  try {
    if (!url.startsWith("/")) {
      connectURL = `/${url}`;
    }

    Object.keys(urlConfig).forEach(urlKey => {
      const val = urlConfig[urlKey];
      if (connectURL.startsWith(urlKey)) {
        connectURL = connectURL.replace(urlKey, val);
      }
    });
    return connectURL;
  } catch (error) {
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/utils/rewriteURL.js